import * as React from 'react';
import { PhonesexNumbers } from './PhonesexNumbers';
import { Block } from './Block';
import { HeaderElements } from '../HeaderElements/HeaderElements';
import PhonesexPageSeotext from "./PhonesexPageSeotext";
import SeoFooter from "../WebmasterKit/SeoFooter";
import H1Header from "../WebmasterKit/H1Header";
import H1Text from "../WebmasterKit/H1Text";
import H2Header from "../WebmasterKit/H2Header";
import H2Text from "../WebmasterKit/H2Text";
export var PhonesexPage = function () {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
  var blocks = [];
  for (var typus in PhonesexNumbers) {
    if (PhonesexNumbers.hasOwnProperty(typus)) {
      var block = PhonesexNumbers[typus];
      // Seo texts
      if ((_b = (_a = window.layoutSettings.seo) === null || _a === void 0 ? void 0 : _a.phonesex) === null || _b === void 0 ? void 0 : _b.hasOwnProperty(typus)) {
        if (((_c = window.layoutSettings.seo) === null || _c === void 0 ? void 0 : _c.phonesex[typus].title.length) > 0) {
          block['title'] = (_d = window.layoutSettings.seo) === null || _d === void 0 ? void 0 : _d.phonesex[typus].title;
        }
        if (((_e = window.layoutSettings.seo) === null || _e === void 0 ? void 0 : _e.phonesex[typus].text.length) > 0) {
          block['description'] = (_f = window.layoutSettings.seo) === null || _f === void 0 ? void 0 : _f.phonesex[typus].text;
        }
        if (((_g = window.layoutSettings.seo) === null || _g === void 0 ? void 0 : _g.phonesex[typus].image.length) > 0) {
          block['imageUrl'] = (_h = window.layoutSettings.seo) === null || _h === void 0 ? void 0 : _h.phonesex[typus].image;
        }
      }
      blocks.push(/*#__PURE__*/React.createElement(Block, {
        key: typus,
        info: block
      }));
    }
  }
  var phonesex = (_k = (_j = window.layoutSettings.seo) === null || _j === void 0 ? void 0 : _j.extraSubPages) === null || _k === void 0 ? void 0 : _k.phonesex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderElements, {
    canIndex: window.index.phonesex,
    title: (_l = phonesex === null || phonesex === void 0 ? void 0 : phonesex.meta) === null || _l === void 0 ? void 0 : _l.title,
    description: (_m = phonesex === null || phonesex === void 0 ? void 0 : phonesex.meta) === null || _m === void 0 ? void 0 : _m.description
  }), /*#__PURE__*/React.createElement("div", {
    className: 'prodwidth center l-container h-center'
  }, /*#__PURE__*/React.createElement(H1Header, {
    text: (_o = phonesex === null || phonesex === void 0 ? void 0 : phonesex.h1) === null || _o === void 0 ? void 0 : _o.title
  }), /*#__PURE__*/React.createElement(H1Text, {
    text: (_p = phonesex === null || phonesex === void 0 ? void 0 : phonesex.h1) === null || _p === void 0 ? void 0 : _p.text
  }), /*#__PURE__*/React.createElement(H2Header, {
    text: (_q = phonesex === null || phonesex === void 0 ? void 0 : phonesex.h2) === null || _q === void 0 ? void 0 : _q.title
  }), /*#__PURE__*/React.createElement(H2Text, {
    text: (_r = phonesex === null || phonesex === void 0 ? void 0 : phonesex.h2) === null || _r === void 0 ? void 0 : _r.text
  }), /*#__PURE__*/React.createElement("div", {
    className: 'page c-phonesex-page',
    id: 'phonesexPage'
  }, blocks), /*#__PURE__*/React.createElement(PhonesexPageSeotext, null), /*#__PURE__*/React.createElement(SeoFooter, {
    text: (_s = phonesex === null || phonesex === void 0 ? void 0 : phonesex.footer) === null || _s === void 0 ? void 0 : _s.text
  })));
};
export default PhonesexPage;